import { useSelector } from "react-redux";

export const useAuth = () => {
  const { token, user, isAuthenticated } = useSelector((state) => state.auth);

  return {
    token,
    user,
    isAuthenticated,
    role: user?.role || null,
    emailAddress: user?.emailAddress || null,
    userId: user?.userId || null,
    isAdmin: user?.role === "Admin",
    isUser: user?.role === "User",
  };
};
